import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  pageNo: 1,
  pageSize: 10,
};

export const doctorReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("GET_ALL_DOCTORS_LIST_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_DOCTORS_LIST_SUCCESS", (state, action) => {
      state.loading = false;
      state.doctorsList = action.payload?.doctorsList;
      state.pageNo = action.payload?.pageNo;
      state.pageSize = action.payload?.pageSize;
    })
    .addCase("GET_ALL_DOCTORS_LIST_FAIL", (state, action) => {
      state.loading = false;
    });
});
